export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractError(e, fallback = "Unexpected error") {
  const d = e?.response?.data?.detail;
  if (d) return formatApiErrorDetail(d);
  if (e?.message) return e.message;
  return fallback;
}
